import { clearSubcontractor } from '../State/subcontractor';
import { resetActiveTab } from '../State/activeTab';

export default () => async (dispatch) => {

  dispatch(clearSubcontractor());
  dispatch(resetActiveTab());

}